<div class="d-flex justify-content-around">
    <div class="form-group ">
        <label for="">Choisir la classe</label>
        <select class="mx-1 form-control" (change)="loadStudents($event)" >
            <option selected disabled></option>
            <option *ngFor="let pac of pacs" [value]="pac.id">{{pac?.classroom?.name}}</option>
        </select>
    </div>
    <div class="form-group ">
        <label for="">Choisir la période</label>
        <select class="mx-1 form-control" [(ngModel)]="periodId" name="periodId" (change)="loadProjectAy($event)">
            <option selected disabled></option>
            <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
        </select>
    </div>
    <div class="form-group ">
        <label for="">Choisir l'apprenant</label>
        <select class="mx-1 form-control" (change)="setSacId($event)"  >
            <option selected disabled></option>
            <option *ngFor="let sac of students" [value]="sac?.id">{{sac?.student?.lastname}} {{sac?.student?.firstname}}</option>
        </select>
    </div>
  
</div>

<div class="text-center py-3">
    <button  class="btn btn-outline-danger" (click)="getTemplate()" *ngIf="classroomId!=undefined && periodId!=undefined">Générer le livret à vide de cette classe</button>
</div>


<div class="container py-5">
    <h5 class="text-center"><strong>Suivi des acquis scolaires de l’élève</strong></h5>
    <form class="mb-5" #addForm="ngForm" (ngSubmit)="storeLevelSkill(addForm.value)">

    <table class="table table-sm table-bordered">
       <thead>
        <tr>
            <th colspan="2" rowspan="2">Domaines d'enseignements</th>
            <th rowspan="2">Principaux éléments du programme travaillés durant la période</th>
            <th rowspan="2">Acquisition, progrès et difficultés éventuelles</th>
            <th attr.colspan="{{sanctions.length}}">
                <dl>
                    <dt>Positionnement</dt>
                    <dd>Objectifs d’apprentissage</dd>
                </dl>
            </th>
        </tr>
        <tr>
            <th *ngFor="let s of sanctions" style=" writing-mode: vertical-lr;transform: rotate(180deg);">{{s}}</th>
        </tr>
       </thead>
       <tbody>
       
        <ng-container *ngIf="sacInfo!=undefined" >
                 <tr *ngFor="let c of sacInfo; let i=index">
                    <ng-container *ngIf="c.has_subs">
                        <td >
                            <div class="d-flex justify-content-between">
                                <span>{{c.name}}</span>
                            </div>
                            
                            </td>
                            <td>
                                <ul *ngFor="let sb of c.details; let j=index">
                                    <li>
                                        <span>{{sb.name}}</span>
                                        <hr>
                                    </li>
                                </ul>
                            </td>
                            <td>
                                <ng-container *ngFor="let sb of c.details; let j=index">
                                    <ul>
                                        <li *ngFor="let sk of sb.details; let k=index">
                                                {{sk.name}}
                                                <hr>                                   
                                        </li>
                                        
                                    </ul>
                                </ng-container>
                                
                            </td>
                    </ng-container>
                    <ng-container *ngIf="!c.has_subs">
                        <td  attr.rowspan="{{c.index}}" colspan="2">
                            <div class="d-flex justify-content-between">
                                <span>{{c.name}}</span>
                            </div>
                            
                            </td>
                            <td>
                                <ul>
                                    <li *ngFor="let sk of c.details; let k=index">
                                            {{sk.name}}
                                            <hr>                                   
                                    </li>
                                    
                                </ul>
                            </td>
                    </ng-container>
                    
               
                <td >
                    <textarea name="message" [(ngModel)]="sacInfo[i].message" class="form-control"></textarea>
                </td>
                <td *ngFor="let s of sanctions; let r=index">
                    <ng-container *ngIf="c.has_subs">
                        <ng-container *ngFor="let sb of c.details; let j=index">
                        <ul>
                            <li *ngFor="let sk of sb.details; let k=index">
                                <div class="form-check">
                                    <input class="form-check-input" [value]="r+1" [(ngModel)]="sacInfo[i]['details'][j]['details'][k].status" type="radio" name="status{{sk.id}}" id="flexRadioDefault{{sk.id}}">
                                  </div>    
                                  <hr>                       
                            </li>
                            
                        </ul>
                    </ng-container>
                </ng-container>
                    <ng-container *ngIf="!c.has_subs">
                        <ul>
                            <li *ngFor="let sk of c?.details; let k=index">
                                <div class="form-check" *ngIf="sacInfo[i]['details'][k]!= undefined">
                                    <input class="form-check-input" [value]="r+1" [(ngModel)]="sacInfo[i]['details'][k].status" type="radio" name="status{{sk.id}}" id="flexRadioDefault{{sk.id}}">
                                  </div>    
                                  <hr>                       
                            </li>
                            
                        </ul>
                    </ng-container>
                   
                   
                </td>
                 </tr>
                 <!-- <tr *ngFor="let sb of c.pacc.subs; let i=index;">
                    <td *ngIf="i==0" attr.rowspan="{{c.pacc.subs.length}}"   style="writing-mode: vertical-lr;transform: rotate(180deg);">
                    <div class="d-flex justify-content-between">
                        <span>{{c.name}}</span>
                        <span (click)="add(addContent,c.pacc.id)"><i  class="fa fa-plus text-primary" style="cursor: pointer;"></i></span>
                    </div>
                    </td>
                    <td>{{sb.name}}</td>
                    <td>
                        <ul>
                            <li *ngFor="let sk of sb.skills; let k=index">
                                    {{sk.name}}
                                    <hr>                                   
                            </li>
                            
                        </ul>
                        <span (click)="add2(addContent2,sb.id)">Ajouter une compétence <i  class="fa fa-plus text-primary" style="cursor: pointer;"></i></span>
                    </td>
                    <td *ngIf="i==0" attr.rowspan="{{c.pacc.subs.length}}" >
                        <textarea name="message" ngModel class="form-control"  [readonly]="sacInfo==undefined"></textarea>
                    </td>
                    <td *ngFor="let s of sanctions; let r=index">
                        <ul>
                            <li *ngFor="let sk of sb.skills; let k=index">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="flexRadioDefault{{i}}{{k}}" id="flexRadioDefault{{i}}{{k}}"  [readonly]="sacInfo==undefined">
                                  </div>    
                                  <hr>                       
                            </li>
                            
                        </ul>
                       
                    </td>
                 </tr> -->
                
             
        </ng-container>
        <ng-container *ngIf="sacInfo==undefined" >
            <ng-container *ngFor="let c of courses">
                <ng-container *ngIf="c.subcourses.length ==0">
                 <tr>
                    <td  colspan="2">
                    <div class="d-flex justify-content-between">
                        <span>{{c.name}}</span>
                        <!-- <span (click)="add(addContent,c.pacc.id)"><i  class="fa fa-plus text-primary" style="cursor: pointer;"></i></span> -->
                    </div>
                    
                </td>
                <td>
                    <ul>
                        <li *ngFor="let sk of c.pacc?.skills; let k=index">
                                {{sk.name}}
                                <hr>                                   
                        </li>
                        
                    </ul>
                    <span (click)="add(addContent2,c.pacc.id)">Ajouter une compétence <i  class="fa fa-plus text-primary" style="cursor: pointer;"></i></span>
                </td>
                <td >
                    <textarea name="message" ngModel class="form-control" [readonly]="sacInfo==undefined"></textarea>
                </td>
                <td *ngFor="let s of sanctions; let r=index">
                    <ul>
                        <li *ngFor="let sk of c.pacc?.skills; let k=index">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="flexRadioDefault{{k}}" id="flexRadioDefault{{k}}"   *ngIf="sacInfo!=undefined">
                              </div>    
                              <hr>                       
                        </li>
                        
                    </ul>
                   
                </td>
                 </tr>
                </ng-container>
                <ng-container *ngIf="c.subcourses.length !=0">
                    <tr *ngFor="let sb of c.subcourses; let i=index;">
                        <td *ngIf="i==0" attr.rowspan="{{c.subcourses.length}}"   style="writing-mode: vertical-lr;transform: rotate(180deg);">
                        <div class="d-flex justify-content-between">
                            <span>{{c.name}}</span>
                            <!-- <span (click)="add(addContent,c.pacc.id)"><i  class="fa fa-plus text-primary" style="cursor: pointer;"></i></span> -->
                        </div>
                        </td>
                        <td>{{sb.name}}</td>
                        <td>
                            <ul>
                                <li *ngFor="let sk of sb.skills; let k=index">
                                        {{sk.name}}
                                        <hr>                                   
                                </li>
                                
                            </ul>
                            <span (click)="add2(addContent2,sb.id)">Ajouter une compétence <i  class="fa fa-plus text-primary" style="cursor: pointer;"></i></span>
                        </td>
                        <td *ngIf="i==0" attr.rowspan="{{c.subcourses.length}}" >
                            <textarea name="message" ngModel class="form-control"  [readonly]="sacInfo==undefined"></textarea>
                        </td>
                        <td *ngFor="let s of sanctions; let r=index">
                            <ul>
                                <li *ngFor="let sk of sb.skills; let k=index">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="flexRadioDefault{{i}}{{k}}" id="flexRadioDefault{{i}}{{k}}"  *ngIf="sacInfo!=undefined">
                                      </div>    
                                      <hr>                       
                                </li>
                                
                            </ul>
                           
                        </td>
                     </tr>
                 
                </ng-container>
                
             
            </ng-container>
        </ng-container>
           
            

        
       </tbody>
    </table>

    <div class="text-end">
        <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
      </div>
  </form>

  <ng-container *ngIf="periodId!=undefined && pacId!=undefined">
    <div class="text-end mb-1">
        <button class="btn btn-sm btn-primary" (click)="add3(addContent3)">Ajouter</button>
    </div>
    <table class="mb-5" class="table table-sm">
        <thead>
            <th>Projet(s) mis en œuvre </th>
        </thead>
        <tbody>
            <tr *ngFor="let p of projects">
                <td>{{p.title}}</td>
            </tr>
        </tbody>
    </table>
  </ng-container>
  <ng-container  *ngIf="periodId!=undefined && sacId!=undefined">
    <h5 class="text-center"><strong>Bilan de l’acquisition des connaissances et compétences</strong></h5>
    <form class="mb-5" #addForm="ngForm" (ngSubmit)="storeAssessment(addForm.value)">

    <div class="form-group">
        <label for="">Appréciation générale sur la progression de l’élève :</label>
        <textarea name="message" ngModel class="form-control" required></textarea>
    </div>
    <div class="text-end">
        <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
      </div>
  </form>
  </ng-container>
   
</div>

<div class="text-center py-5">
    <button (click)="generateAssessmentBulletin()" [disabled]="loading" class="btn btn-outline-danger" *ngIf="sacInfo!=undefined && ab==null">Générer le livret</button>
    <button (click)="generateAssessmentBulletin()" [disabled]="loading" class="btn btn-outline-danger" *ngIf="sacInfo!=undefined && ab!=null">Regénérer le livret</button>
</div>


<ng-template #addContent3 let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="storePay(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Ajouter un projet mise en oeuvre</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="title" class="form-control" ngModel>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="storeSubCourse(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Ajouter une subdivision au cours</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" ngModel>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
<ng-template #addContent2 let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="storeSkill(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Ajouter une compétence</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" ngModel>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>


  <ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>
